var _style, _line, _line2, _line3, _rect, _g, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _line28, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _line29, _line30, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _ellipse, _line31, _line32, _line33, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _line34, _path39, _path40, _line35, _line36, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _ellipse2, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48, _line49, _line50, _line51, _line52, _line53, _path98, _path99, _line54, _line55, _line56, _line57, _line58, _line59, _path100, _line60, _path101, _path102, _path103, _rect4, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _line61, _path120, _rect5, _path121, _rect6, _path122, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _path123, _path124, _path125, _path126, _path127, _line62, _line63, _line64, _path128, _path129, _line65, _path130, _line66, _path131, _line67, _line68, _line69, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _line70, _path142, _path143, _path144, _path145;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSupportScene(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_137",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1340.6 188.2",
    style: {
      enableBackground: "new 0 0 1340.6 188.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#0F324F;stroke-width:1.5;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st1{fill:none;}\r\n\t.st2{fill:none;stroke:#0A3951;stroke-width:1.5;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st3{fill:none;stroke:#0F324F;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st4{fill:none;stroke:#0B3A51;stroke-width:1.5;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st5{fill:#CCD9ED;}\r\n\t.st6{fill:#EAEFF9;}\r\n\t.st7{fill:#FFFFFF;}\r\n\t.st8{fill:none;stroke:#083851;stroke-width:1.5;stroke-miterlimit:10;}\r\n\t.st9{fill:none;stroke:#0F324F;stroke-width:1.5;stroke-miterlimit:10;}\r\n\t.st10{fill:none;stroke:#083851;stroke-width:1.5;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st11{fill:#90AED5;}\r\n\t.st12{fill:none;stroke:#0F324F;stroke-width:1.5;}\r\n\t.st13{fill:none;stroke:#0F324F;stroke-width:1.5003;stroke-miterlimit:4.0008;}\r\n\t.st14{fill:#AEC3E1;}\r\n\t.st15{fill:none;stroke:#0A3951;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}\r\n")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_357",
    className: "st0",
    x1: 1203.6,
    y1: 170,
    x2: 1207.4,
    y2: 170
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line_358",
    className: "st0",
    x1: 1162,
    y1: 170,
    x2: 1198.3,
    y2: 170
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "Line_359",
    className: "st0",
    x1: 1188.3,
    y1: 173.6,
    x2: 1247.8,
    y2: 173.6
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 1340.6,
    height: 188.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_132"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_360",
    className: "st0",
    x1: 1212.9,
    y1: 169.9,
    x2: 1339.8,
    y2: 169.9
  }))), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    id: "Line_361",
    className: "st0",
    x1: 1032.3,
    y1: 170,
    x2: 1095.4,
    y2: 170
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    id: "Line_362",
    className: "st2",
    x1: 1040,
    y1: 173.6,
    x2: 1046.2,
    y2: 173.6
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    id: "Line_363",
    className: "st0",
    x1: 980.8,
    y1: 170,
    x2: 1023.9,
    y2: 170
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    id: "Line_364",
    className: "st0",
    x1: 902.2,
    y1: 170,
    x2: 975.4,
    y2: 170
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    id: "Line_365",
    className: "st0",
    x1: 712.3,
    y1: 170,
    x2: 897.9,
    y2: 170
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    id: "Line_366",
    className: "st0",
    x1: 639.2,
    y1: 170,
    x2: 704.3,
    y2: 170
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    id: "Line_367",
    className: "st2",
    x1: 630.9,
    y1: 170,
    x2: 634.5,
    y2: 170
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    id: "Line_368",
    className: "st0",
    x1: 592.7,
    y1: 170,
    x2: 625.4,
    y2: 170
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    id: "Line_369",
    className: "st0",
    x1: 418.9,
    y1: 170,
    x2: 589.3,
    y2: 170
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    id: "Line_370",
    className: "st2",
    x1: 408.9,
    y1: 170,
    x2: 412.7,
    y2: 170
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    id: "Line_371",
    className: "st2",
    x1: 367.3,
    y1: 170,
    x2: 403.7,
    y2: 170
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    id: "Line_372",
    className: "st0",
    x1: 265.8,
    y1: 170,
    x2: 358.3,
    y2: 170
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    id: "Line_373",
    className: "st0",
    x1: 203.1,
    y1: 170,
    x2: 255.5,
    y2: 170
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    id: "Line_374",
    className: "st0",
    x1: 239.5,
    y1: 173.6,
    x2: 298.5,
    y2: 173.6
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    id: "Line_375",
    className: "st2",
    x1: 393.7,
    y1: 173.6,
    x2: 520,
    y2: 173.6
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    id: "Line_376",
    className: "st0",
    x1: 393.7,
    y1: 173.6,
    x2: 520,
    y2: 173.6
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    id: "Line_377",
    className: "st0",
    x1: 582.3,
    y1: 173.6,
    x2: 641.3,
    y2: 173.6
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    id: "Line_378",
    className: "st0",
    x1: 676.4,
    y1: 173.6,
    x2: 725.2,
    y2: 173.6
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    id: "Line_379",
    className: "st0",
    x1: 891.8,
    y1: 173.6,
    x2: 1018.6,
    y2: 173.6
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    id: "Line_380",
    className: "st2",
    x1: 646.1,
    y1: 173.6,
    x2: 649.8,
    y2: 173.6
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    id: "Line_381",
    className: "st0",
    x1: 735.3,
    y1: 173.6,
    x2: 738.9,
    y2: 173.6
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    id: "Line_382",
    className: "st2",
    x1: 882.6,
    y1: 173.6,
    x2: 886.2,
    y2: 173.6
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    id: "Line_383",
    className: "st0",
    x1: 777.2,
    y1: 173.6,
    x2: 817.3,
    y2: 173.6
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    id: "Line_384",
    className: "st0",
    x1: 539.5,
    y1: 173.6,
    x2: 566.7,
    y2: 173.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 1340.6,
    height: 188.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_182",
    x: 377.3,
    y: 118.6,
    className: "st3",
    width: 15.3,
    height: 3.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_686",
    className: "st0",
    d: "M195.9,161.7c3.8,4.8,2,11.5,3,8.8s2.5-7,4.2-8.3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_687",
    className: "st0",
    d: "M191.2,166.1c2.1,1.1,3.7,2.8,4.6,5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_688",
    className: "st4",
    d: "M359.5,164.5c4,5.2,2.5,13,3.7,6.7l1.2-6.4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_689",
    className: "st0",
    d: "M712.3,158.8c-5.4,5.1-3.3,12.8-5,6.6l-1.7-6.3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_690",
    className: "st0",
    d: "M1022.3,161.7c7.2,5,4.4,12.5,6.7,6.4l2.2-6.1"
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    id: "Line_385",
    className: "st0",
    x1: 348.6,
    y1: 173.6,
    x2: 357.7,
    y2: 173.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_691",
    className: "st5",
    d: "M220.9,104.6c-1.7,2-4.2,3.2-6.8,3.2c-4.3,0.1-7.9-3-8.5-7.2l0,0c-5.8,2.9-12.6,2.5-18-1.2 c-1.8-1.3-3.4-2.9-4.6-4.8l0,0c-2.2,1.3-4.6,1.9-7.1,1.9c-7.5,0-13.6-5.7-13.6-12.8c0-2.9,1-5.7,2.9-7.9l0,0 c-0.2-0.2-0.5-0.4-0.7-0.7c-8.4-7.7-8.9-20.6-1.3-29c0.4-0.5,0.8-0.9,1.3-1.3c3.2-3,7.3-5.1,11.6-5.9l0,0c-0.9-2.8-1.3-5.6-1.3-8.5 c0-16.3,14.1-29.5,31.4-29.5c13,0,24.2,7.4,29,18l0,0c3.3-2.6,7.4-4.1,11.6-4c6.9-0.2,13.2,3.8,16.1,10.1c2.1-0.4,4.2-0.6,6.4-0.6 c17.4,0,31.6,13.3,31.6,29.7c0,11.3-6.7,21.1-16.5,26.1l0,0c1,2,1.5,4.3,1.5,6.6c0,5.1-2.7,9.9-7,12.7c-6.2,4.1-14.3,3.8-20.2-0.7 l-0.1,0.2c-2.4,3.3-6.2,5.2-10.2,5.1c-1.6,0-3.3-0.3-4.8-0.9L220.9,104.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_692",
    className: "st3",
    d: "M167.5,93.6c-3.2-2.3-5.2-6.1-5.2-10c0-2.9,1-5.7,2.9-7.9l0,0c-0.2-0.2-0.5-0.4-0.7-0.7 c-8.4-7.6-8.9-20.6-1.3-29c0.4-0.5,0.8-0.9,1.3-1.3c3.2-3,7.3-5.1,11.6-5.9l0,0c-1.9-6-1.8-12.4,0.4-18.3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_693",
    className: "st3",
    d: "M290.3,76c-1.8,1.6-3.9,2.9-6,4l0,0c1,2,1.5,4.3,1.5,6.6c0,5.1-2.7,9.9-7,12.7 c-6.2,4.1-14.3,3.8-20.2-0.7l-0.1,0.2c-2.4,3.3-6.2,5.2-10.3,5.1c-1.6,0-3.3-0.3-4.8-0.9l-22.6,1.6c-1.7,2-4.2,3.2-6.8,3.2 c-4.3,0.1-7.9-3-8.5-7.2l0,0c-5.8,2.9-12.6,2.5-18-1.2c-1.8-1.3-3.4-2.9-4.6-4.8l0,0c-2.2,1.3-4.6,1.9-7.1,1.9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_694",
    className: "st3",
    d: "M181.4,12.2c6.2-7.3,15.3-11.5,24.8-11.4c13,0,24.2,7.4,29,18l0,0c3.3-2.6,7.4-4.1,11.6-4 c6.9-0.2,13.2,3.8,16.1,10.1c2.1-0.4,4.2-0.6,6.4-0.6c17.4,0,31.6,13.3,31.6,29.7c0,6.1-2,12-5.6,16.9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_695",
    className: "st6",
    d: "M258.4,180.8c-9.3-4.7-15.6-13.9-15.6-24.5V94.4c0-6.4,5.5-11.6,12.3-11.6h0.2 c-1.4-3-1.2-6.4,0.5-9.2l0-0.1c-4.6,1.6-9.7,1.2-14-1.1l-0.1,0c-5.3,2.7-8.3,5.8-8.3,9.1c0-3.1-2.6-6-7.2-8.6v0 c-3.7-0.8-6.8-3.2-8.5-6.6c-0.1-0.2-0.2-0.4-0.2-0.6l0,0c-1,2.4-2.9,4.3-5.3,5.2c-1.6,0.7-3.3,0.9-5.1,0.7l0,0 c0.1,0.2,0.3,0.5,0.4,0.7c1.5,3.2,1.8,6.9,0.8,10.3h0.5c6.8,0,12.3,5.2,12.3,11.6v61.9c0,10.6-6.3,19.8-15.6,24.5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_696",
    className: "st3",
    d: "M258.4,180.8c-9.3-4.7-15.6-13.9-15.6-24.5V94.4c0-6.4,5.5-11.6,12.3-11.6h0.2 c-1.4-3-1.2-6.4,0.5-9.2l0-0.1c-4.6,1.6-9.7,1.2-14-1.1l-0.1,0c-5.3,2.7-8.3,5.8-8.3,9.1c0-3.1-2.6-6-7.2-8.6v0 c-3.7-0.8-6.8-3.2-8.5-6.6c-0.1-0.2-0.2-0.4-0.2-0.6l0,0c-1,2.4-2.9,4.3-5.3,5.2c-1.6,0.7-3.3,0.9-5.1,0.7l0,0 c0.1,0.2,0.3,0.5,0.4,0.7c1.5,3.2,1.8,6.9,0.8,10.3h0.5c6.8,0,12.3,5.2,12.3,11.6v61.9c0,10.6-6.3,19.8-15.6,24.5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_697",
    className: "st3",
    d: "M203.5,89.8c5.1-4.2,6.7-11.4,3.9-17.4c-0.1-0.2-0.2-0.5-0.4-0.7l0,0c1.7,0.2,3.5-0.1,5.1-0.7 c2.4-1,4.3-2.8,5.3-5.2l0,0c0.1,0.2,0.2,0.4,0.2,0.6c2.8,5.9,10.1,8.5,16.3,6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_698",
    className: "st3",
    d: "M256.3,84.6c-2.4-3.2-2.6-7.6-0.5-11l0-0.1c-5.8,2-12.2,0.8-16.9-3"
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    id: "Line_386",
    className: "st0",
    x1: 238.3,
    y1: 123.3,
    x2: 238.3,
    y2: 96.3
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    id: "Line_387",
    className: "st0",
    x1: 238.3,
    y1: 134.1,
    x2: 238.3,
    y2: 128
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_699",
    className: "st5",
    d: "M1094.8,58.4c0-0.7,0-1.4,0-2.1c0.8-12.8,12.6-22.6,26.2-21.8c3.1,0.2,6.1,0.9,9,2.1 c0.6,0.2,1.2,0.5,1.7,0.8l0.3,0.2c4.6-5.5,11.5-8.5,18.6-8.1c10.4,0.6,18.6,7.9,20.1,17.2c3.2-1.4,6.7-2.1,10.1-1.9 c11.3,0.7,19.9,9.8,19.2,20.4c-0.2,3.8-1.6,7.4-4,10.3l0,0c0.1,0.9,0.1,1.8,0.1,2.7c-0.5,8.2-7.5,14.7-16,15.3c0,0.1,0,0.3,0,0.4 c-0.6,9.2-9,16.2-18.8,15.6c-1.2-0.1-2.4-0.2-3.5-0.5l0,0c-3.8,5-9.9,7.8-16.2,7.4c-5.8-0.3-11.1-3.2-14.4-8l0,0 c-4.7,4.8-11.3,7.3-18,6.9c-12.3-0.7-21.7-10.7-20.9-22.3c0.4-6,3.4-11.5,8.2-15l0,0c-5.7-2.8-8.2-9.6-5.4-15.4 C1091.9,61,1093.2,59.5,1094.8,58.4L1094.8,58.4z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_700",
    className: "st3",
    d: "M1191.3,88.6c-3,2.9-7,4.7-11.2,5c0,0.1,0,0.3,0,0.4c-0.6,9.2-9,16.2-18.8,15.6 c-1.2-0.1-2.4-0.2-3.5-0.5l0,0c-3.8,5-9.9,7.8-16.2,7.4c-5.8-0.3-11.1-3.2-14.4-8l0,0c-4.7,4.8-11.3,7.3-18,6.9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_701",
    className: "st3",
    d: "M1127.8,35.8c0.7,0.2,1.5,0.5,2.2,0.8c0.6,0.2,1.2,0.5,1.7,0.8l0.3,0.2 c4.6-5.5,11.5-8.5,18.7-8.1c10.4,0.6,18.6,7.9,20.1,17.2c3.2-1.4,6.7-2.1,10.1-1.9c11.3,0.7,19.9,9.8,19.2,20.4 c-0.2,3.8-1.6,7.4-4,10.3l0,0c0.1,0.9,0.1,1.8,0.1,2.7"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_702",
    className: "st3",
    d: "M1100.7,113.3c-7.8-3.6-13-11.4-12.4-20.1c0.4-6,3.4-11.5,8.2-15l0,0c-5.7-2.8-8.2-9.6-5.4-15.4 c0.8-1.7,2.1-3.2,3.6-4.4l0,0c0-0.7,0-1.4,0-2.1c0.8-12.8,12.6-22.6,26.2-21.8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_703",
    className: "st3",
    d: "M1123.1,94.6l0.1-0.1c3.5-0.2,6.7-1.8,9.1-4.3c1-1,1.8-2.3,2.4-3.6c5.3-0.2,10-3.2,11.2-7.7 c0-0.2,0.1-0.4,0.1-0.6h0c2.7,2.1,6.5,2.6,9.6,1.1l0,0c0,0.1-0.1,0.3-0.1,0.4c-1,3.7,1.3,7.5,5.2,9.3c0.8,0.4,1.6,0.6,2.4,0.8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_704",
    className: "st6",
    d: "M1172.5,174.7c-9.3-4.7-15.6-13.9-15.6-24.5V97.5c0-3,1.3-6,3.5-8.1l0.3-0.2 c-3.9-1.8-6.1-5.6-5.2-9.3c0-0.1,0.1-0.3,0.1-0.4l0,0c-3.2,1.5-6.9,1-9.6-1.1h0c0,0.2-0.1,0.4-0.1,0.6c-1.2,4.6-5.9,7.5-11.2,7.7 c-0.6,1.3-1.4,2.5-2.4,3.6l0.1,0.1c1.8,2,2.7,4.6,2.7,7.2v52.7c0,10.6-6.3,19.8-15.6,24.5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_705",
    className: "st3",
    d: "M1172.5,174.7c-9.3-4.7-15.6-13.9-15.6-24.5V97.5c0-3,1.3-6,3.5-8.1l0.3-0.2 c-3.9-1.8-6.1-5.6-5.2-9.3c0-0.1,0.1-0.3,0.1-0.4l0,0c-3.2,1.5-6.9,1-9.6-1.1h0c0,0.2-0.1,0.4-0.1,0.6c-1.2,4.6-5.9,7.5-11.2,7.7 c-0.6,1.3-1.4,2.5-2.4,3.6l0.1,0.1c1.8,2,2.7,4.6,2.7,7.2v52.7c0,10.6-6.3,19.8-15.6,24.5"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_44",
    className: "st0",
    cx: 1142.9,
    cy: 116.4,
    rx: 3.3,
    ry: 3.1
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    id: "Line_388",
    className: "st0",
    x1: 77.7,
    y1: 170,
    x2: 191.1,
    y2: 170
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    id: "Line_389",
    className: "st0",
    x1: 0.8,
    y1: 170,
    x2: 65.1,
    y2: 170
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    id: "Line_390",
    className: "st0",
    x1: 45.4,
    y1: 173.6,
    x2: 117.7,
    y2: 173.6
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_706",
    className: "st7",
    d: "M1012.4,56.9c-6.3-5.5-19.3-13.9-42.8-17.9c-0.8-0.2-1.6,0.2-2.1,0.8l-3.1,5.6 c-2,3.5-5.7,8.8-5.6,14l54.4-0.1C1013.6,58.4,1013.2,57.5,1012.4,56.9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_707",
    className: "st8",
    d: "M1012.4,56.9c-6.3-5.5-19.3-13.9-42.8-17.9c-0.8-0.2-1.6,0.2-2.1,0.8l-3.1,5.6 c-2,3.5-5.7,8.8-5.6,14l54.4-0.1C1013.5,58.4,1013.2,57.5,1012.4,56.9z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_708",
    className: "st7",
    d: "M946.5,131.4H430.9c-0.7,0-1.3-0.5-1.3-1.3V31.1c0-0.7,0.6-1.3,1.3-1.3h515.6 c0.7,0,1.3,0.5,1.3,1.3v99.1C947.8,130.9,947.2,131.5,946.5,131.4"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_166",
    className: "st8",
    d: "M430.7,29.8h515.9c0.7,0,1.2,0.5,1.2,1.2v99.2c0,0.7-0.5,1.2-1.2,1.2l0,0H430.7 c-0.7,0-1.2-0.5-1.2-1.2c0,0,0,0,0,0V31.1C429.5,30.4,430.1,29.8,430.7,29.8z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_709",
    className: "st7",
    d: "M742.6,144.4v12.6c0,1.4-1.2,2.4-2.5,2.4H460.5c-1.4,0-2.5-1-2.5-2.4v-12.6h-22.6 c-1.4,0-2.5-1-2.5-2.4v-10.5H800l-49.7,11.7C747.8,143.8,745.2,144.1,742.6,144.4L742.6,144.4z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_710",
    className: "st8",
    d: "M742.6,144.4v12.6c0,1.4-1.2,2.4-2.5,2.4H460.5c-1.4,0-2.5-1-2.5-2.4v-12.6h-22.6 c-1.4,0-2.5-1-2.5-2.4v-10.5H800l-49.7,11.7C747.8,143.8,745.2,144.1,742.6,144.4L742.6,144.4z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_711",
    className: "st7",
    d: "M1056.4,135.2v22.6c0,0.8-0.7,1.5-1.5,1.4H804.6c-0.8,0-1.5-0.6-1.5-1.4v-6 c0-0.8-0.7-1.5-1.5-1.4c-0.8,0-1.5-0.6-1.5-1.4v-5.4c0-0.7,0.5-1.3,1.2-1.4l18.1-4.4c0.1,0,0.3,0,0.4,0h151.6c0.8,0,1.5-0.6,1.5-1.4 v-2.7c0-0.2,0-0.4-0.1-0.6l-4.1-8.8c-0.3-0.7,0-1.6,0.8-1.9c0.2-0.1,0.4-0.1,0.6-0.1h85c0.8,0,1.5,0.6,1.5,1.4L1056.4,135.2z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_712",
    className: "st8",
    d: "M1056.4,135.2v22.6c0,0.8-0.7,1.5-1.5,1.4H804.6c-0.8,0-1.5-0.6-1.5-1.4v-6 c0-0.8-0.7-1.5-1.5-1.4c-0.8,0-1.5-0.6-1.5-1.4v-5.4c0-0.7,0.5-1.3,1.2-1.4l18.1-4.4c0.1,0,0.3,0,0.4,0h151.6c0.8,0,1.5-0.6,1.5-1.4 v-2.7c0-0.2,0-0.4-0.1-0.6l-4.1-8.8c-0.3-0.7,0-1.6,0.8-1.9c0.2-0.1,0.4-0.1,0.6-0.1h85c0.8,0,1.5,0.6,1.5,1.4L1056.4,135.2z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_713",
    className: "st6",
    d: "M943.1,131.2H733l108.5-102l100.7,0.6L943.1,131.2z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_714",
    className: "st6",
    d: "M809.1,29.8L701.2,131.4H593L701,29.8H809.1z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_715",
    className: "st6",
    d: "M670.3,29.8l-108,101.6h-54.2L616.4,29.6L670.3,29.8z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_716",
    className: "st5",
    d: "M1056.4,144.3l-256.9,0.1l0.9-1.9l19.2-4.8h152.7l0.5-4.2l-3.5-7.9h47.2l11.5,9.6h28.5V144.3z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_717",
    className: "st5",
    d: "M742.6,144.3l-307.3,0.1c-1.3,0-2.4-1-2.5-2.3v-10.6H800L742.6,144.3z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_718",
    className: "st9",
    d: "M1056.4,135.2v22.6c0,0.8-0.7,1.5-1.5,1.4H804.6c-0.8,0-1.5-0.6-1.5-1.4v-6 c0-0.8-0.7-1.5-1.5-1.4c-0.8,0-1.5-0.6-1.5-1.4v-5.4c0-0.7,0.5-1.3,1.2-1.4l18.1-4.4c0.1,0,0.3,0,0.4,0h151.6c0.8,0,1.5-0.6,1.5-1.4 v-2.7c0-0.2,0-0.4-0.1-0.6l-4.1-8.8c-0.3-0.7,0-1.6,0.8-1.9c0.2-0.1,0.4-0.1,0.6-0.1h85c0.8,0,1.5,0.6,1.5,1.4L1056.4,135.2z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_719",
    className: "st7",
    d: "M969.2,125.6h-8.7c-0.8,0-1.5-0.6-1.5-1.4V59.4h66.7c0.2,0,0.5,0.1,0.7,0.2l28.1,13.6 c0.4,0.2,0.8,0.6,0.8,1.1l3.7,29.7c0,0.1,0,0.1,0,0.2v29.7c0,0.8-0.7,1.5-1.5,1.4h-29.6c-0.4,0-0.8-0.2-1.1-0.4l-9.3-8.7 c-0.3-0.3-0.7-0.4-1.1-0.4H983"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_720",
    className: "st10",
    d: "M969.2,125.6h-8.7c-0.8,0-1.5-0.6-1.5-1.4V59.4h66.7c0.2,0,0.5,0.1,0.7,0.2l28.1,13.6 c0.4,0.2,0.8,0.6,0.8,1.1l3.7,29.7c0,0.1,0,0.1,0,0.2v29.7c0,0.8-0.7,1.5-1.5,1.4h-29.6c-0.4,0-0.8-0.2-1.1-0.4l-9.3-8.7 c-0.3-0.3-0.7-0.4-1.1-0.4H983"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_721",
    className: "st10",
    d: "M969.2,125.6h-8.7c-0.8,0-1.5-0.6-1.5-1.4V59.4h66.7c0.2,0,0.5,0.1,0.7,0.2l28.1,13.6 c0.4,0.2,0.8,0.6,0.8,1.1l3.7,29.7c0,0.1,0,0.1,0,0.2v29.7c0,0.8-0.7,1.5-1.5,1.4h-29.6c-0.4,0-0.8-0.2-1.1-0.4l-9.3-8.7 c-0.3-0.3-0.7-0.4-1.1-0.4H983"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_722",
    className: "st9",
    d: "M742.6,144.4v12.6c0,1.4-1.2,2.4-2.5,2.4H460.5c-1.4,0-2.5-1-2.5-2.4v-12.6h-22.6 c-1.4,0-2.5-1-2.5-2.4v-10.5H800l-49.7,11.7C747.8,143.8,745.2,144.1,742.6,144.4L742.6,144.4z"
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    id: "Line_391",
    className: "st0",
    x1: 486.1,
    y1: 144.6,
    x2: 714.2,
    y2: 144.4
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_723",
    className: "st6",
    d: "M1059,104l-11.1-3.6c-0.6-0.2-1-0.7-1-1.4V76.3c0-0.8,0.7-1.5,1.5-1.4h6.9"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_724",
    className: "st9",
    d: "M1059,104l-11.1-3.6c-0.6-0.2-1-0.7-1-1.4V76.3c0-0.8,0.7-1.5,1.5-1.4h6.9"
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    id: "Line_392",
    className: "st0",
    x1: 725.6,
    y1: 144.4,
    x2: 742.4,
    y2: 144.4
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    id: "Line_393",
    className: "st0",
    x1: 457.7,
    y1: 144.4,
    x2: 474.6,
    y2: 144.4
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_725",
    className: "st7",
    d: "M851.8,155.7c0.7,0,1.3-0.5,1.3-1.2c0,0,0,0,0-0.1c-0.7-11.2-10.6-20.1-22.7-20.1 s-22,8.9-22.7,20.1c0,0.7,0.5,1.2,1.2,1.2c0,0,0,0,0.1,0H851.8z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_726",
    className: "st9",
    d: "M851.8,155.7c0.7,0,1.3-0.5,1.3-1.2c0,0,0,0,0-0.1c-0.7-11.2-10.6-20.1-22.7-20.1 s-22,8.9-22.7,20.1c0,0.7,0.5,1.2,1.2,1.2c0,0,0,0,0.1,0H851.8z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_727",
    className: "st6",
    d: "M1019.2,96.1l-7.7-1c-0.7-0.1-1.3-0.7-1.3-1.4V74.1c0-0.8,0.7-1.5,1.5-1.4h26.5 c0.8,0,1.5,0.6,1.5,1.4v23.1c0,0.8-0.7,1.5-1.6,1.5c-0.1,0-0.1,0-0.2,0l-13-1.8"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_728",
    className: "st0",
    d: "M1019.2,96.1l-7.7-1c-0.7-0.1-1.3-0.7-1.3-1.4V74.1c0-0.8,0.7-1.5,1.5-1.4h26.5 c0.8,0,1.5,0.6,1.5,1.4v23.1c0,0.8-0.7,1.5-1.6,1.5c-0.1,0-0.1,0-0.2,0l-13-1.8"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_729",
    className: "st7",
    d: "M903.4,155.7c0.7,0,1.3-0.5,1.3-1.2c0,0,0,0,0-0.1c-0.7-11.2-10.6-20.1-22.7-20.1 s-22,8.9-22.7,20.1c0,0.7,0.5,1.2,1.2,1.2c0,0,0,0,0.1,0H903.4z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_730",
    className: "st9",
    d: "M903.4,155.7c0.7,0,1.3-0.5,1.3-1.2c0,0,0,0,0-0.1c-0.7-11.2-10.6-20.1-22.7-20.1 s-22,8.9-22.7,20.1c0,0.7,0.5,1.2,1.2,1.2c0,0,0,0,0.1,0H903.4z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_731",
    className: "st7",
    d: "M1024.5,155.7c0.7,0,1.3-0.5,1.3-1.2c0,0,0,0,0-0.1c-0.7-11.2-10.6-20.1-22.7-20.1 s-22,8.9-22.7,20.1c0,0.7,0.5,1.2,1.2,1.2c0,0,0,0,0.1,0H1024.5z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_732",
    className: "st9",
    d: "M1024.5,155.7c0.7,0,1.3-0.5,1.3-1.2c0,0,0,0,0-0.1c-0.7-11.2-10.6-20.1-22.7-20.1 s-22,8.9-22.7,20.1c0,0.7,0.5,1.2,1.2,1.2c0,0,0,0,0.1,0H1024.5z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_733",
    className: "st7",
    d: "M555,155.7c0.7,0,1.3-0.5,1.3-1.2c0,0,0,0,0-0.1c-0.7-11.2-10.6-20.1-22.7-20.1 s-22,8.9-22.7,20.1c0,0.7,0.5,1.2,1.2,1.2c0,0,0,0,0.1,0H555z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_734",
    className: "st9",
    d: "M555,155.7c0.7,0,1.3-0.5,1.3-1.2c0,0,0,0,0-0.1c-0.7-11.2-10.6-20.1-22.7-20.1 s-22,8.9-22.7,20.1c0,0.7,0.5,1.2,1.2,1.2c0,0,0,0,0.1,0H555z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_735",
    className: "st7",
    d: "M600.7,155.7c0.7,0,1.3-0.5,1.3-1.2c0,0,0,0,0-0.1c-0.7-11.2-10.6-20.1-22.7-20.1 s-22,8.9-22.7,20.1c0,0.7,0.5,1.2,1.2,1.2c0,0,0,0,0.1,0H600.7z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_736",
    className: "st9",
    d: "M600.7,155.7c0.7,0,1.3-0.5,1.3-1.2c0,0,0,0,0-0.1c-0.7-11.2-10.6-20.1-22.7-20.1 s-22,8.9-22.7,20.1c0,0.7,0.5,1.2,1.2,1.2c0,0,0,0,0.1,0H600.7z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_737",
    className: "st7",
    d: "M646.3,155.7c0.7,0,1.3-0.5,1.3-1.2c0,0,0,0,0-0.1c-0.7-11.2-10.6-20.1-22.7-20.1 s-22,8.9-22.7,20.1c0,0.7,0.5,1.2,1.2,1.2c0,0,0,0,0.1,0H646.3z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_738",
    className: "st9",
    d: "M646.3,155.7c0.7,0,1.3-0.5,1.3-1.2c0,0,0,0,0-0.1c-0.7-11.2-10.6-20.1-22.7-20.1 s-22,8.9-22.7,20.1c0,0.7,0.5,1.2,1.2,1.2c0,0,0,0,0.1,0H646.3z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_739",
    className: "st5",
    d: "M947.6,161.5h-36.4c-1.2,0-2.1-0.9-2.2-2v-16c0-1.2,1-2.1,2.2-2h36.4c1.2,0,2.1,0.9,2.2,2v16 C949.7,160.6,948.7,161.5,947.6,161.5"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_167",
    className: "st9",
    d: "M911,141.4h36.8c1.1,0,2,0.9,2,2v16.1c0,1.1-0.9,2-2,2H911c-1.1,0-2-0.9-2-2v-16.1 C909,142.3,909.9,141.4,911,141.4z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_740",
    className: "st11",
    d: "M900.9,155.7c0-9.9-8.5-17.8-19-17.8s-19,8-19,17.8s8.5,17.8,19,17.8S900.9,165.6,900.9,155.7"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_822",
    className: "st12",
    d: "M881.5,137.9c10.5-0.2,19.2,7.6,19.4,17.4c0.2,9.8-8.1,18-18.6,18.2 c-10.5,0.2-19.2-7.6-19.4-17.4C862.7,146.3,871,138.1,881.5,137.9z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Path_741",
    className: "st11",
    d: "M849.3,155.7c0-9.9-8.5-17.8-19-17.8s-19,8-19,17.8s8.5,17.8,19,17.8S849.3,165.6,849.3,155.7"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Path_823",
    className: "st12",
    d: "M829.9,137.9c10.5-0.2,19.2,7.6,19.4,17.4c0.2,9.8-8.1,18-18.6,18.2 c-10.5,0.2-19.2-7.6-19.4-17.4C811.1,146.3,819.5,138.1,829.9,137.9z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Path_742",
    className: "st11",
    d: "M1022,155.7c0-9.9-8.5-17.8-19-17.8s-19,8-19,17.8s8.5,17.8,19,17.8S1022,165.6,1022,155.7"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Path_824",
    className: "st12",
    d: "M1002.6,137.9c10.5-0.2,19.2,7.6,19.4,17.4c0.2,9.8-8.1,18-18.6,18.2 c-10.5,0.2-19.2-7.6-19.4-17.4C983.9,146.3,992.2,138.1,1002.6,137.9z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Path_743",
    className: "st11",
    d: "M643.9,155.7c0-9.9-8.5-17.8-19-17.8s-19,8-19,17.8s8.5,17.8,19,17.8S643.9,165.6,643.9,155.7"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Path_825",
    className: "st12",
    d: "M624.5,137.9c10.5-0.2,19.2,7.6,19.4,17.4c0.2,9.8-8.1,18-18.6,18.2 c-10.5,0.2-19.2-7.6-19.4-17.4C605.7,146.3,614,138.1,624.5,137.9z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Path_744",
    className: "st11",
    d: "M598.2,155.7c0-9.9-8.5-17.8-19-17.8s-19,8-19,17.8s8.5,17.8,19,17.8S598.2,165.6,598.2,155.7"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Path_826",
    className: "st13",
    d: "M560.3,155.4c0.2-9.9,8.9-17.7,19.4-17.5c10.5,0.2,18.8,8.3,18.6,18.2s-8.9,17.7-19.4,17.5 S560.1,165.2,560.3,155.4z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Path_745",
    className: "st11",
    d: "M552.5,155.7c0-9.9-8.5-17.8-19-17.8c-10.5,0-19,8-19,17.8s8.5,17.8,19,17.8 C544,173.6,552.5,165.6,552.5,155.7"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_50",
    className: "st9",
    cx: 533.6,
    cy: 155.7,
    rx: 19,
    ry: 17.8
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Path_746",
    className: "st7",
    d: "M842.2,155.7c0-6.2-5.3-11.2-11.9-11.2s-11.9,5-11.9,11.2s5.3,11.2,11.9,11.2 S842.2,161.9,842.2,155.7"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Path_747",
    className: "st7",
    d: "M893.8,155.7c0-6.2-5.3-11.2-11.9-11.2s-11.9,5-11.9,11.2s5.3,11.2,11.9,11.2 S893.8,161.9,893.8,155.7"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Path_748",
    className: "st7",
    d: "M1014.9,155.7c0-6.2-5.3-11.2-11.9-11.2s-11.9,5-11.9,11.2s5.3,11.2,11.9,11.2 S1014.9,161.9,1014.9,155.7"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Path_749",
    className: "st7",
    d: "M591.1,155.7c0-6.2-5.3-11.2-11.9-11.2s-11.9,5-11.9,11.2s5.3,11.2,11.9,11.2 S591.1,161.9,591.1,155.7"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Path_750",
    className: "st7",
    d: "M636.8,155.7c0-6.2-5.3-11.2-11.9-11.2s-11.9,5-11.9,11.2s5.3,11.2,11.9,11.2 S636.8,161.9,636.8,155.7"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Path_751",
    className: "st7",
    d: "M545.4,155.7c0-6.2-5.3-11.2-11.9-11.2s-11.9,5-11.9,11.2s5.3,11.2,11.9,11.2 S545.4,161.9,545.4,155.7"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Path_752",
    className: "st0",
    d: "M523,160.9c3.4,5.8,11,7.7,16.8,4.3c1.8-1.1,3.2-2.5,4.3-4.3"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Path_753",
    className: "st0",
    d: "M544.1,150.6c-3.4-5.8-11-7.7-16.8-4.3c-1.7,1-3.2,2.4-4.2,4.1"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Path_754",
    className: "st0",
    d: "M568.7,160.9c3.4,5.8,11,7.7,16.8,4.3c1.8-1.1,3.2-2.5,4.3-4.3"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Path_755",
    className: "st0",
    d: "M589.8,150.6c-3.4-5.8-11-7.7-16.8-4.3c-1.7,1-3.2,2.4-4.2,4.1"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Path_756",
    className: "st0",
    d: "M614.4,160.9c3.4,5.8,11,7.7,16.8,4.3c1.8-1.1,3.2-2.5,4.3-4.3"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Path_757",
    className: "st0",
    d: "M635.4,150.6c-3.4-5.8-11-7.7-16.8-4.3c-1.7,1-3.2,2.4-4.2,4.1"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Path_758",
    className: "st0",
    d: "M819.8,160.9c3.4,5.8,11,7.7,16.8,4.3c1.8-1.1,3.2-2.5,4.3-4.3"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "Path_759",
    className: "st0",
    d: "M840.9,150.6c-3.4-5.8-11-7.7-16.8-4.3c-1.7,1-3.2,2.4-4.2,4.1"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Path_760",
    className: "st0",
    d: "M871.4,160.9c3.4,5.8,11,7.7,16.8,4.3c1.8-1.1,3.2-2.5,4.3-4.3"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "Path_761",
    className: "st0",
    d: "M892.4,150.6c-3.4-5.8-11-7.7-16.8-4.3c-1.7,1-3.2,2.4-4.2,4.1"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "Path_762",
    className: "st0",
    d: "M992.5,160.9c3.4,5.8,11,7.7,16.8,4.3c1.8-1.1,3.2-2.5,4.3-4.3"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "Path_763",
    className: "st0",
    d: "M1013.6,150.6c-3.4-5.8-11-7.7-16.8-4.3c-1.7,1-3.2,2.4-4.2,4.1"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "Path_764",
    className: "st7",
    d: "M837.8,155.7c0.3-4.1-2.9-7.7-7-8c-4.1-0.3-7.7,2.9-8,7c-0.3,4.1,2.9,7.7,7,8c0.2,0,0.3,0,0.5,0 C834.4,162.9,837.7,159.7,837.8,155.7"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "Path_765",
    className: "st9",
    d: "M837.8,155.7c0.3-4.1-2.9-7.7-7-8c-4.1-0.3-7.7,2.9-8,7c-0.3,4.1,2.9,7.7,7,8c0.2,0,0.3,0,0.5,0 C834.4,162.9,837.7,159.7,837.8,155.7z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "Path_766",
    className: "st7",
    d: "M889.4,155.7c0.3-4.1-2.9-7.7-7-8c-4.1-0.3-7.7,2.9-8,7c-0.3,4.1,2.9,7.7,7,8c0.2,0,0.3,0,0.5,0 C885.9,162.9,889.3,159.7,889.4,155.7"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "Path_767",
    className: "st9",
    d: "M889.4,155.7c0.3-4.1-2.9-7.7-7-8c-4.1-0.3-7.7,2.9-8,7c-0.3,4.1,2.9,7.7,7,8c0.2,0,0.3,0,0.5,0 C885.9,162.9,889.3,159.7,889.4,155.7z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "Path_768",
    className: "st7",
    d: "M1010.6,155.7c0.3-4.1-2.9-7.7-7-8c-4.1-0.3-7.7,2.9-8,7c-0.3,4.1,2.9,7.7,7,8c0.2,0,0.3,0,0.5,0 C1007.1,162.9,1010.4,159.7,1010.6,155.7"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "Path_769",
    className: "st9",
    d: "M1010.6,155.7c0.3-4.1-2.9-7.7-7-8c-4.1-0.3-7.7,2.9-8,7c-0.3,4.1,2.9,7.7,7,8c0.2,0,0.3,0,0.5,0 C1007.1,162.9,1010.4,159.7,1010.6,155.7z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "Path_770",
    className: "st7",
    d: "M586.7,155.7c0.3-4.1-2.9-7.7-7-8c-4.1-0.3-7.7,2.9-8,7c-0.3,4.1,2.9,7.7,7,8c0.2,0,0.3,0,0.5,0 C583.2,162.9,586.6,159.7,586.7,155.7"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "Path_771",
    className: "st9",
    d: "M586.7,155.7c0.3-4.1-2.9-7.7-7-8c-4.1-0.3-7.7,2.9-8,7c-0.3,4.1,2.9,7.7,7,8c0.2,0,0.3,0,0.5,0 C583.2,162.9,586.6,159.7,586.7,155.7z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "Path_772",
    className: "st7",
    d: "M632.4,155.7c0.3-4.1-2.9-7.7-7-8c-4.1-0.3-7.7,2.9-8,7c-0.3,4.1,2.9,7.7,7,8c0.2,0,0.3,0,0.5,0 C628.9,162.9,632.3,159.7,632.4,155.7"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "Path_773",
    className: "st9",
    d: "M632.4,155.7c0.3-4.1-2.9-7.7-7-8c-4.1-0.3-7.7,2.9-8,7c-0.3,4.1,2.9,7.7,7,8c0.2,0,0.3,0,0.5,0 C628.9,162.9,632.3,159.7,632.4,155.7z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: "Path_774",
    className: "st7",
    d: "M541.1,155.7c0.3-4.1-2.9-7.7-7-8c-4.1-0.3-7.7,2.9-8,7c-0.3,4.1,2.9,7.7,7,8c0.2,0,0.3,0,0.5,0 C537.6,162.9,540.9,159.7,541.1,155.7"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "Path_775",
    className: "st9",
    d: "M541.1,155.7c0.3-4.1-2.9-7.7-7-8c-4.1-0.3-7.7,2.9-8,7c-0.3,4.1,2.9,7.7,7,8c0.2,0,0.3,0,0.5,0 C537.6,162.9,540.9,159.7,541.1,155.7z"
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    id: "Line_394",
    className: "st0",
    x1: 463.3,
    y1: 118.6,
    x2: 463.3,
    y2: 131.2
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    id: "Line_395",
    className: "st0",
    x1: 491.5,
    y1: 118.6,
    x2: 491.5,
    y2: 131.2
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    id: "Line_396",
    className: "st0",
    x1: 519.7,
    y1: 118.6,
    x2: 519.7,
    y2: 131.2
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    id: "Line_397",
    className: "st0",
    x1: 547.8,
    y1: 118.6,
    x2: 547.8,
    y2: 131.2
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    id: "Line_398",
    className: "st0",
    x1: 576,
    y1: 118.6,
    x2: 576,
    y2: 131.2
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    id: "Line_399",
    className: "st0",
    x1: 604.2,
    y1: 118.6,
    x2: 604.2,
    y2: 131.2
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    id: "Line_400",
    className: "st0",
    x1: 632.3,
    y1: 118.6,
    x2: 632.3,
    y2: 131.2
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    id: "Line_401",
    className: "st0",
    x1: 660.5,
    y1: 118.6,
    x2: 660.5,
    y2: 131.2
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    id: "Line_402",
    className: "st0",
    x1: 688.7,
    y1: 118.6,
    x2: 688.7,
    y2: 131.2
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    id: "Line_403",
    className: "st0",
    x1: 716.9,
    y1: 118.6,
    x2: 716.9,
    y2: 131.2
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    id: "Line_404",
    className: "st0",
    x1: 745,
    y1: 118.6,
    x2: 745,
    y2: 131.2
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    id: "Line_405",
    className: "st0",
    x1: 773.2,
    y1: 118.6,
    x2: 773.2,
    y2: 131.2
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    id: "Line_406",
    className: "st0",
    x1: 801.4,
    y1: 118.6,
    x2: 801.4,
    y2: 131.2
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    id: "Line_407",
    className: "st0",
    x1: 829.5,
    y1: 118.6,
    x2: 829.5,
    y2: 131.2
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    id: "Line_408",
    className: "st0",
    x1: 857.7,
    y1: 118.6,
    x2: 857.7,
    y2: 131.2
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    id: "Line_409",
    className: "st0",
    x1: 885.9,
    y1: 118.6,
    x2: 885.9,
    y2: 131.2
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    id: "Line_410",
    className: "st0",
    x1: 914.1,
    y1: 118.6,
    x2: 914.1,
    y2: 131.2
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    id: "Path_776",
    className: "st5",
    d: "M740.1,42.5l-310.7,0.1V29.6l518.4,0.2v12.7L740.1,42.5z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_168",
    className: "st9",
    d: "M430.7,29.8h515.9c0.7,0,1.2,0.5,1.2,1.2v99.2c0,0.7-0.5,1.2-1.2,1.2l0,0H430.7 c-0.7,0-1.2-0.5-1.2-1.2c0,0,0,0,0,0V31.1C429.5,30.4,430.1,29.8,430.7,29.8z"
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    id: "Line_411",
    className: "st0",
    x1: 435,
    y1: 29.8,
    x2: 435,
    y2: 131.4
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    id: "Line_412",
    className: "st0",
    x1: 942.1,
    y1: 29.8,
    x2: 942.1,
    y2: 131.4
  })), _line56 || (_line56 = /*#__PURE__*/React.createElement("line", {
    id: "Line_413",
    className: "st0",
    x1: 1046.9,
    y1: 144.4,
    x2: 1028.8,
    y2: 144.4
  })), _line57 || (_line57 = /*#__PURE__*/React.createElement("line", {
    id: "Line_414",
    className: "st0",
    x1: 1046.9,
    y1: 151.5,
    x2: 1031.7,
    y2: 151.5
  })), _line58 || (_line58 = /*#__PURE__*/React.createElement("line", {
    id: "Line_415",
    className: "st0",
    x1: 917.8,
    y1: 144.3,
    x2: 917.8,
    y2: 158.6
  })), _line59 || (_line59 = /*#__PURE__*/React.createElement("line", {
    id: "Line_416",
    className: "st0",
    x1: 940.9,
    y1: 144.3,
    x2: 940.9,
    y2: 158.6
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: "Path_777",
    className: "st0",
    d: "M969.2,125.6h-8.7c-0.8,0-1.5-0.6-1.5-1.4V59.4h66.7c0.2,0,0.5,0.1,0.7,0.2l28.1,13.6 c0.4,0.2,0.8,0.6,0.8,1.1l3.7,29.7c0,0.1,0,0.1,0,0.2v29.7c0,0.8-0.7,1.5-1.5,1.4h-29.6c-0.4,0-0.8-0.2-1.1-0.4l-9.3-8.7 c-0.3-0.3-0.7-0.4-1.1-0.4H983"
  })), _line60 || (_line60 = /*#__PURE__*/React.createElement("line", {
    id: "Line_417",
    className: "st0",
    x1: 1010.2,
    y1: 119.8,
    x2: 963.8,
    y2: 119.8
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: "Path_778",
    className: "st5",
    d: "M967.6,39.8l-3.1,5.6c-0.4,0.7-0.7,1.4-1.1,2c17,2.1,33.8,6.1,49.9,11.9c0.2-0.9-0.2-1.9-1-2.4 c-6.3-5.5-19.3-13.9-42.8-17.9C968.9,38.8,968.1,39.1,967.6,39.8"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    id: "Path_779",
    className: "st9",
    d: "M1012.4,56.9c-6.3-5.5-19.3-13.9-42.8-17.9c-0.8-0.2-1.6,0.2-2.1,0.8l-3.1,5.6 c-2,3.5-5.7,8.8-5.6,14l54.4-0.1C1013.5,58.4,1013.2,57.5,1012.4,56.9z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1348",
    className: "st14",
    d: "M374.4,115.3h21.2v3.2h-21.2V115.3z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_170",
    x: 374.4,
    y: 115.3,
    className: "st3",
    width: 21.2,
    height: 3.2
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    id: "Path_780",
    className: "st7",
    d: "M484.9,172.5c1.2-0.2,2-1.2,2.1-2.4v-9c0-1.6-0.2-3.1-0.6-4.6c-0.2-0.8-0.5-1.6-0.8-2.5 c-1.6-4.3-5.2-7.6-9.6-8.8c-11.3-3.2-30.9-5.4-34.9-5.9c-0.5-0.1-1-0.2-1.4-0.4c0,0-18.4-11-25.9-13.6s-16.9-4-28.6-4 c-12.4,0-25.6,1.9-31.7,3.6c-13.9,3.8-20.7,7.4-26.9,9.6c-5.1,1.7-16.4,4.4-20.7,5.4c-1,0.2-1.8,1-2,1.9l-2.1,8.5 c-0.8,3.3-1.2,6.6-1.2,10v3.9c0,2.1,1.5,3.9,3.5,4.4l8.7,2.3c1.4,0.4,2.9-0.3,3.3-1.7c0.1-0.3,0.1-0.6,0.1-0.9 c-0.1-0.7-0.1-1.4,0-2.2c0.4-8.5,7.9-15.6,17-15.9c10.1-0.4,18.5,7.2,18.5,16.7c0,1.2-0.2,2.5-0.5,3.7c-0.2,1.4,0.7,2.7,2.1,3 c0.2,0,0.4,0,0.5,0h84.9c1.4,0,2.6-1.1,2.7-2.5c0-0.2,0-0.4-0.1-0.6c-0.3-1.6-0.5-3.2-0.3-4.8c0.6-8.3,8.1-15.1,17-15.4 c10.1-0.4,18.5,7.2,18.5,16.7c0,1.1-0.1,2.2-0.4,3.3c-0.2,1.4,0.7,2.7,2.1,2.9c0.3,0,0.5,0,0.8,0C481.1,173,483.7,172.7,484.9,172.5 "
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    id: "Path_781",
    className: "st15",
    d: "M484.9,172.5c1.2-0.2,2-1.2,2.1-2.4v-9c0-1.6-0.2-3.1-0.6-4.6c-0.2-0.8-0.5-1.6-0.8-2.5 c-1.6-4.3-5.2-7.6-9.6-8.8c-11.3-3.2-30.9-5.4-34.9-5.9c-0.5-0.1-1-0.2-1.4-0.4c0,0-18.4-11-25.9-13.6s-16.9-4-28.6-4 c-12.4,0-25.6,1.9-31.7,3.6c-13.9,3.8-20.7,7.4-26.9,9.6c-5.1,1.7-16.4,4.4-20.7,5.4c-1,0.2-1.8,1-2,1.9l-2.1,8.5 c-0.8,3.3-1.2,6.6-1.2,10v3.9c0,2.1,1.5,3.9,3.5,4.4l8.7,2.3c1.4,0.4,2.9-0.3,3.3-1.7c0.1-0.3,0.1-0.6,0.1-0.9 c-0.1-0.7-0.1-1.4,0-2.2c0.4-8.5,7.9-15.6,17-15.9c10.1-0.4,18.5,7.2,18.5,16.7c0,1.2-0.2,2.5-0.5,3.7c-0.2,1.4,0.7,2.7,2.1,3 c0.2,0,0.4,0,0.5,0h84.9c1.4,0,2.6-1.1,2.7-2.5c0-0.2,0-0.4-0.1-0.6c-0.3-1.6-0.5-3.2-0.3-4.8c0.6-8.3,8.1-15.1,17-15.4 c10.1-0.4,18.5,7.2,18.5,16.7c0,1.1-0.1,2.2-0.4,3.3c-0.2,1.4,0.7,2.7,2.1,2.9c0.3,0,0.5,0,0.8,0C481.2,173,483.7,172.7,484.9,172.5 z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    id: "Path_782",
    className: "st5",
    d: "M443.1,159h-93.6c-3.4-5.4-9.3-8.6-15.6-8.7c-10.7,0-15.3,8.4-15.6,8.7h-17.7l1.7-10.7l1.5-6.3 c0.5-0.5,1.1-1.7,2-1.9l126.1,0h12.5c2,0.3,29.3,5.2,31.3,5.2l5.7,3.1l3.6,4.9l1.1,5.8h-12.1c0,0-4.1-8.7-15.6-8.7 S443.1,159,443.1,159"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    id: "Path_783",
    className: "st6",
    d: "M343.8,140h88.2c0,0-15.6-15.7-44.8-15.2c-25.2,0.4-35.9,6-42.2,10.1 C341.3,137.3,342.2,140,343.8,140"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    id: "Path_784",
    className: "st15",
    d: "M343.8,140h88.2c0,0-15.6-15.7-44.8-15.2c-25.2,0.4-35.9,6-42.2,10.1 C341.3,137.3,342.2,140,343.8,140z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    id: "Path_785",
    className: "st11",
    d: "M472.2,167c0-7.1-6.1-12.8-13.6-12.8S445,159.9,445,167s6.1,12.8,13.6,12.8S472.2,174,472.2,167 "
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    id: "Path_786",
    className: "st9",
    d: "M472.2,167c0-7.1-6.1-12.8-13.6-12.8S445,159.9,445,167s6.1,12.8,13.6,12.8S472.2,174,472.2,167z "
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    id: "Path_787",
    className: "st7",
    d: "M467.2,167c0.3-4.7-3.3-8.7-8-9c-4.7-0.3-8.7,3.3-9,8c-0.3,4.7,3.3,8.7,8,9c0.2,0,0.3,0,0.5,0 C463.2,175.1,467,171.5,467.2,167"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    id: "Path_788",
    className: "st0",
    d: "M453.9,169.3c1.6,2.6,5,3.5,7.6,1.9c0.8-0.5,1.5-1.1,1.9-1.9"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    id: "Path_789",
    className: "st0",
    d: "M463.4,164.6c-1.6-2.6-5-3.5-7.6-1.9c-0.8,0.5-1.4,1.1-1.9,1.9"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    id: "Path_790",
    className: "st11",
    d: "M347.5,167c0-7.1-6.1-12.8-13.6-12.8s-13.6,5.7-13.6,12.8s6.1,12.8,13.6,12.8 S347.5,174,347.5,167"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    id: "Path_791",
    className: "st9",
    d: "M347.5,167c0-7.1-6.1-12.8-13.6-12.8s-13.6,5.7-13.6,12.8s6.1,12.8,13.6,12.8 S347.5,174,347.5,167z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    id: "Path_792",
    className: "st7",
    d: "M342.4,167c0.3-4.7-3.3-8.7-8-9c-4.7-0.3-8.7,3.3-9,8c-0.3,4.7,3.3,8.7,8,9c0.2,0,0.3,0,0.5,0 C338.5,175.1,342.3,171.5,342.4,167"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    id: "Path_793",
    className: "st0",
    d: "M329.1,169.3c1.6,2.6,5,3.5,7.6,1.9c0.8-0.5,1.5-1.1,1.9-1.9"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    id: "Path_794",
    className: "st0",
    d: "M338.7,164.6c-1.6-2.6-5-3.5-7.6-1.9c-0.8,0.5-1.4,1.1-1.9,1.9"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    id: "Path_795",
    className: "st5",
    d: "M345.9,140h-2.1c-1.6,0-2.6-2.7,1.2-5.1c6.3-4.1,17-9.7,42.2-10.1c29.2-0.5,44.8,15.2,44.8,15.2 h-6.2c-7.2-4.5-20-10.3-37.9-10C363,130.4,352.2,135.9,345.9,140"
  })), _line61 || (_line61 = /*#__PURE__*/React.createElement("line", {
    id: "Line_418",
    className: "st3",
    x1: 387.2,
    y1: 124.8,
    x2: 387.2,
    y2: 140
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    id: "Path_796",
    className: "st7",
    d: "M310.7,159.1h-10.1v-2.4l0.4-3.4l1-3.7h8.7L310.7,159.1z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_171",
    x: 310.7,
    y: 140,
    className: "st7",
    width: 10.1,
    height: 9.5
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    id: "Path_797",
    className: "st7",
    d: "M325.4,152.4l-2.8,1.8l-1.8,1.5v-6.3H331v1.1L325.4,152.4z"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_172",
    x: 331,
    y: 140,
    className: "st7",
    width: 10.1,
    height: 9.5
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    id: "Path_798",
    className: "st7",
    d: "M351.2,159.1h-1.7l-3.6-4.3l-4.8-3.1v-2.2h10.1V159.1z"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_173",
    x: 351.2,
    y: 140,
    className: "st7",
    width: 10.1,
    height: 9.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_174",
    x: 361.3,
    y: 149.5,
    className: "st7",
    width: 10.1,
    height: 9.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_175",
    x: 371.5,
    y: 140,
    className: "st7",
    width: 10.1,
    height: 9.5
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_176",
    x: 381.6,
    y: 149.6,
    className: "st7",
    width: 10.1,
    height: 9.5
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_177",
    x: 391.7,
    y: 140,
    className: "st7",
    width: 10.1,
    height: 9.5
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_178",
    x: 401.8,
    y: 149.5,
    className: "st7",
    width: 10.1,
    height: 9.5
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_179",
    x: 411.9,
    y: 140.1,
    className: "st7",
    width: 10.1,
    height: 9.5
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_180",
    x: 422,
    y: 149.6,
    className: "st7",
    width: 10.1,
    height: 9.5
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_181",
    x: 432.2,
    y: 140,
    className: "st7",
    width: 10.1,
    height: 9.5
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    id: "Path_799",
    className: "st7",
    d: "M446.8,154.2l-3.8,4.8h-0.8v-9.5h10.1v1.9L446.8,154.2z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    id: "Path_800",
    className: "st7",
    d: "M462.5,149.6h-10.1v-8.9l4.3,0.4l4.1,0.9l1.7,0.3L462.5,149.6z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    id: "Path_801",
    className: "st7",
    d: "M469,153.3l-6.5-2.6v-1.1h10.1v7.5L469,153.3z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    id: "Path_802",
    className: "st7",
    d: "M482.8,149.6h-10.1v-5.3l4.7,1.3l4.3,2.6L482.8,149.6z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    id: "Path_803",
    className: "st7",
    d: "M487.3,159.1l-4.5-0.1v-9.5l3.6,5.4L487.3,159.1z"
  })), _line62 || (_line62 = /*#__PURE__*/React.createElement("line", {
    id: "Line_419",
    className: "st3",
    x1: 385,
    y1: 118.6,
    x2: 385,
    y2: 115.3
  })), _line63 || (_line63 = /*#__PURE__*/React.createElement("line", {
    id: "Line_420",
    className: "st3",
    x1: 394.5,
    y1: 159,
    x2: 443.1,
    y2: 159
  })), _line64 || (_line64 = /*#__PURE__*/React.createElement("line", {
    id: "Line_421",
    className: "st15",
    x1: 474.2,
    y1: 159,
    x2: 480.5,
    y2: 159
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    id: "Path_804",
    className: "st7",
    d: "M425.3,140c-1.3,0.1-2.4-0.8-2.7-2c-0.2-1.3,0.8-2.6,2.1-2.7c0.1,0,0.3,0,0.4,0 c0.4,0,0.8,0.1,1.1,0.3c2,1.4,4,2.9,5.8,4.5H425.3z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    id: "Path_805",
    className: "st3",
    d: "M425.3,140c-1.3,0.1-2.4-0.8-2.7-2c-0.2-1.3,0.8-2.6,2.1-2.7c0.1,0,0.3,0,0.4,0 c0.4,0,0.8,0.1,1.1,0.3c2,1.4,4,2.9,5.8,4.5H425.3z"
  })), _line65 || (_line65 = /*#__PURE__*/React.createElement("line", {
    id: "Line_422",
    className: "st3",
    x1: 394.5,
    y1: 148.2,
    x2: 403.8,
    y2: 148.2
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    id: "Path_806",
    className: "st3",
    d: "M484.9,172.5c1.2-0.2,2-1.2,2.1-2.4v-9c0-1.6-0.2-3.1-0.6-4.6c-0.2-0.8-0.5-1.6-0.8-2.5 c-1.6-4.3-5.2-7.6-9.6-8.8c-11.3-3.2-30.9-5.4-34.9-5.9c-0.5-0.1-1-0.2-1.4-0.4c0,0-18.4-11-25.9-13.6s-16.9-4-28.6-4 c-12.4,0-25.6,1.9-31.7,3.6c-13.9,3.8-20.7,7.4-26.9,9.6c-5.1,1.7-16.4,4.4-20.7,5.4c-1,0.2-1.8,1-2,1.9l-2.1,8.5 c-0.8,3.3-1.2,6.6-1.2,10v3.9c0,2.1,1.5,3.9,3.5,4.4l8.7,2.3c1.4,0.4,2.9-0.3,3.3-1.7c0.1-0.3,0.1-0.6,0.1-0.9 c-0.1-0.7-0.1-1.4,0-2.2c0.4-8.5,7.9-15.6,17-15.9c10.1-0.4,18.5,7.2,18.5,16.7c0,1.2-0.2,2.5-0.5,3.7c-0.2,1.4,0.7,2.7,2.1,3 c0.2,0,0.4,0,0.5,0h84.9c1.4,0,2.6-1.1,2.7-2.5c0-0.2,0-0.4-0.1-0.6c-0.3-1.6-0.5-3.2-0.3-4.8c0.6-8.3,8.1-15.1,17-15.4 c10.1-0.4,18.5,7.2,18.5,16.7c0,1.1-0.1,2.2-0.4,3.3c-0.2,1.4,0.7,2.7,2.1,2.9c0.3,0,0.5,0,0.8,0C481.2,173,483.7,172.7,484.9,172.5 z"
  })), _line66 || (_line66 = /*#__PURE__*/React.createElement("line", {
    id: "Line_423",
    className: "st3",
    x1: 387.2,
    y1: 148.2,
    x2: 387.2,
    y2: 169.3
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    id: "Path_807",
    className: "st3",
    d: "M343.8,140h88.2c0,0-15.6-15.7-44.8-15.2c-25.2,0.4-35.9,6-42.2,10.1 C341.3,137.3,342.2,140,343.8,140z"
  })), _line67 || (_line67 = /*#__PURE__*/React.createElement("line", {
    id: "Line_424",
    className: "st3",
    x1: 357,
    y1: 159,
    x2: 386.3,
    y2: 159
  })), _line68 || (_line68 = /*#__PURE__*/React.createElement("line", {
    id: "Line_425",
    className: "st3",
    x1: 308.3,
    y1: 159,
    x2: 318.3,
    y2: 159
  })), _line69 || (_line69 = /*#__PURE__*/React.createElement("line", {
    id: "Line_426",
    className: "st3",
    x1: 348.9,
    y1: 148.2,
    x2: 358.1,
    y2: 148.2
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    id: "Path_808",
    className: "st5",
    d: "M323.4,187.3l10.4,0.1c1.6-2.6,2.4-5.7,2.4-8.8c0-9.9-8.5-17.8-19-17.8c-2.8,0-7.8,1.6-7.8,1.6 c-0.8-5.5-5.6-9.5-11.2-9.4c-3.6,0-7,1.6-9.2,4.5c-1.3,1.7-2,3.9-2,6.1c0,0.7,0.1,1.4,0.2,2.1l0,0c-2.3,0.6-4.4,1.6-6.3,3 c-3.8,2.9-6.1,7.4-6.2,12.1c0,2.1,0.4,4.2,1.3,6.1l41.7,0.3"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    id: "Path_809",
    className: "st1",
    d: "M289,157.5c-1.8,2.3-2.4,5.3-1.8,8.2l0,0c-2.3,0.6-4.4,1.6-6.3,3c-3.8,2.9-6.1,7.4-6.2,12.1 c0,2.1,0.4,4.2,1.3,6.1l14.7,0.1l11.4,0.1l15.7,0.1"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    id: "Path_810",
    className: "st0",
    d: "M289,157.5c-1.8,2.3-2.4,5.3-1.8,8.2l0,0c-2.3,0.6-4.4,1.6-6.3,3c-3.8,2.9-6.1,7.4-6.2,12.1 c0,2.1,0.4,4.2,1.3,6.1l14.7,0.1l11.4,0.1l15.7,0.1"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    id: "Path_811",
    className: "st1",
    d: "M323.4,187.3l10.4,0.1c1.6-2.6,2.4-5.7,2.4-8.8c0-9.9-8.5-17.8-19-17.8c-2.8,0-7.8,1.6-7.8,1.6 c-0.8-5.5-5.6-9.5-11.2-9.4"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    id: "Path_812",
    className: "st0",
    d: "M323.4,187.3l10.4,0.1c1.6-2.6,2.4-5.7,2.4-8.8c0-9.9-8.5-17.8-19-17.8c-2.8,0-7.8,1.6-7.8,1.6 c-0.8-5.5-5.6-9.5-11.2-9.4"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    id: "Path_813",
    className: "st1",
    d: "M328.9,176.7c-0.8-5.5-5.6-9.5-11.2-9.4"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    id: "Path_814",
    className: "st0",
    d: "M328.9,176.7c-0.8-5.5-5.6-9.5-11.2-9.4"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    id: "Path_815",
    className: "st1",
    d: "M298.5,173.6c-5.3-3-12-1.5-15.4,3.6"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    id: "Path_816",
    className: "st0",
    d: "M298.5,173.6c-5.3-3-12-1.5-15.4,3.6"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    id: "Path_817",
    className: "st5",
    d: "M1122.2,158.1c9.9,2.8,17.1,11.4,17.1,21.6c0,1.6-0.2,3.3-0.6,4.9h-98.8c-1-2.5-1.4-5.1-1.4-7.7 c0-12.4,10.7-22.4,23.9-22.4c4,0,7.9,0.9,11.4,2.7l0.3,0.2c4.3-4.6,10.4-7.2,16.7-7.2c4.6,0,9,1.3,12.9,3.9c2.1-2.5,5.1-3.9,8.3-3.9 C1116.7,150,1121,153.3,1122.2,158.1L1122.2,158.1z"
  })), _line70 || (_line70 = /*#__PURE__*/React.createElement("line", {
    id: "Line_427",
    className: "st0",
    x1: 1092.9,
    y1: 184.5,
    x2: 1059.8,
    y2: 184.5
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    id: "Path_818",
    className: "st0",
    d: "M1069.3,155.4c1.5,0.4,3,1,4.4,1.7l0.3,0.2c4.3-4.6,10.4-7.2,16.7-7.2c4.6,0,9,1.3,12.9,3.9 l0.2-0.2c2-2.4,5-3.8,8.2-3.7c4.9-0.1,9.1,3.2,10.3,7.9l0,0c9.9,2.8,17.1,11.4,17.1,21.6c0,1.6-0.2,3.3-0.6,4.9h-37.1"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    id: "Path_819",
    className: "st0",
    d: "M1050.8,184.5h-11c-1-2.5-1.4-5.1-1.4-7.7c0-12.4,10.7-22.4,23.9-22.4"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    id: "Path_820",
    className: "st0",
    d: "M1074.5,173.8c-0.5-3.5,0.7-7.1,3.3-9.5c4.1-3.8,10.3-4.5,15.1-1.6"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    id: "Path_821",
    className: "st0",
    d: "M1111.8,164.2c7-1.3,14,2,17.5,8.2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportScene);
export default __webpack_public_path__ + "static/media/support-scene.028b61b17cf7a3372113bda20430ba6e.svg";
export { ForwardRef as ReactComponent };